import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
@Injectable()
export class AuthenticationService {

  public redirectUrl: string;
  constructor(private http: Http, private router: Router) { }

  public isEmailRegistered(userEmail) {
    console.log('email', userEmail);
    return this.http.get(environment.baseUrl + '/user/isRegistered/' + userEmail).map((response: Response) => {
            console.log(response.status);
            const user = response.json();
            user.responseStatus = response.status;
            console.log(user);
            if (response.status === 200 ) {
              return user;
            }
          }).catch((error) => {
            console.log('error', error);
            if (error.status === 500) {
              console.log('status', error.status);
              const err = error.json();
              err.responseStatus = error.status;
              console.log('status', err.responseStatus);
              return Observable.throw(err);
            } else if (error.status === 400) {
              console.log('status', error.status);
              const err = error.json();
              err.responseStatus = error.status;
              console.log('status', err.responseStatus);
              return Observable.throw(err);
            } else if (error.status === 401) {
              console.log('status', error.status);
              const err = error.json();
              err.responseStatus = error.status;
              console.log('status', err.responseStatus);
              return Observable.throw(err);
            }
        });
  }

  public Newregister(formdata) {
    const email = formdata.emailId;
    console.log('email.', email);
    const validEmail = email.toLowerCase();
    console.log('validEmail', validEmail);
    const data = {
      'emailId': validEmail,
      'password': formdata.password,
      'roles': [formdata.role],
      "termsAndConditions": formdata.agree,
      "question" : "",
      "answer": "",
      // "mobileNumber": "+91"+formdata.mobileNumber
      "mobileNumber": formdata.mobileNumber
     
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/register', body, {headers: head}).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public isTokenValid(token) {
    console.log('token', token);
    return this.http.get(environment.baseUrl + '/user/confirm_token/' + token).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }
  



  public resendEmail(emailId) {
    console.log('token', emailId);
    const data = {
      'emailId': emailId
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/register', body, {headers: head}).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public validateEmail(formdata) {
    // console.log('un+++', formdata.username);
    // const params: URLSearchParams = new URLSearchParams();
    // params.set('email', formdata.emailId);
    // params.set('username', formdata.username);

    return this.http.get(environment.baseUrl + '/user/otp/' + formdata.emailId + '/' + formdata.username ).map((response: Response) => {
            console.log(response.status);
            const user = response.json();
            user.responseStatus = response.status;
            console.log(user);
            if (response.status === 200 ) {
              return user;
            }
          }).catch((error) => {
            console.log('error', error);
            if (error.status === 500) {
              console.log('status', error.status);
              const err = error.json();
              err.responseStatus = error.status;
              console.log('status', err.responseStatus);
              return Observable.throw(err);
            } else if (error.status === 400) {
              console.log('status', error.status);
              const err = error.json();
              err.responseStatus = error.status;
              console.log('status', err.responseStatus);
              return Observable.throw(err);
            } else if (error.status === 401) {
              console.log('status', error.status);
              const err = error.json();
              err.responseStatus = error.status;
              console.log('status', err.responseStatus);
              return Observable.throw(err);
            }
        });
  }

  public sendOtp(formdata) {
    console.log('formdata', formdata);
      const data = {
        'mobileNumber': formdata.mobileNumber,
      
     };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/otp', body, {headers: head}).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });

  }
  // validate otp
  public validateOtp(formdata) {
    console.log('formdata', formdata);
      const data = {
        'mobileNumber': formdata.mobileNumber,
        "otp": formdata.otp
     };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/otplogin', body, {headers: head}).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });

  }

  public register(formdata) {
    const data = {
        'fullName': formdata.fullname,
        'emailId': formdata.emailId,
        'username': formdata.username,
        'password': formdata.password
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/register', body, {headers: head}).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public login(formdata) {

    const email = formdata.emailId;

    const validEmail = email.toLowerCase();

    const data = {
      'emailId': validEmail,
      'password': formdata.password
    };

    const body = JSON.stringify(data);

    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/logIn', body, {headers: head}).map((response: Response) => {

      if (this.redirectUrl) {
        this.router.navigate([this.redirectUrl]);
        this.redirectUrl = null;
      } else {

        const user = response.json();
        user.responseStatus = response.status;
;
        return user;
      }
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public forgotPassword(forgotPswd) {
    console.log('inside forgotPassword services', forgotPswd);
    const data = {
      'emailId': forgotPswd.email
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/forgotpassword', body, {headers: head}).map((response: Response) => {
      console.log(this.redirectUrl);
      if (this.redirectUrl) {
        this.router.navigate([this.redirectUrl]);
        this.redirectUrl = null;
      } else {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public resetPassword(formdata, email, oldPassword) {
    const data = {
        'emailId': email,
        'newPassword': formdata.password,
        'oldPassword': oldPassword
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    const head = new Headers({
        'Content-Type': 'application/json'
    });
    return this.http.post(environment.baseUrl + '/user/resetpassword', body, {headers: head}).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  // chanel onboarded user approve
  public approveUser(token) {
    console.log('token', token);
    return this.http.get(environment.baseUrl + '/user/approve_token/' + token).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }
  // chanel onboarded user reject
  public rejectUser(token) {
    console.log('token', token);
    return this.http.get(environment.baseUrl + '/user/reject_token/' + token).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      if (response.status === 200 ) {
        return user;
      }
     }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

// pan Validation
// public panValidation(formdata) {
//   console.log('inside services', formdata);

//   const data = {
//     "pinCode": formdata.pinCode,
//     "city":formdata.city
//   };
//   console.log('data', data);
//   const body = JSON.stringify(data);
//   console.log(body);
//   const head = new Headers({
//       'Content-Type': 'application/json'
//   });
//   return this.http.post(environment.baseUrl + '/validation/pincode', body, {headers: head}).map((response: Response) => {
//     console.log(this.redirectUrl);
//     if (this.redirectUrl) {
//       this.router.navigate([this.redirectUrl]);
//       this.redirectUrl = null;
//     } else {
//       console.log(response.status);
//       const user = response.json();
//       user.responseStatus = response.status;
//       console.log(user);
//       return user;
//     }
//   }).catch((error) => {
//     console.log('error', error);
//     if (error.status === 500) {
//       console.log('status', error.status);
//       const err = error.json();
//       err.responseStatus = error.status;
//       console.log('status', err.responseStatus);
//       return Observable.throw(err);
//     } else if (error.status === 400) {
//       console.log('status', error.status);
//       const err = error.json();
//       err.responseStatus = error.status;
//       console.log('status', err.responseStatus);
//       return Observable.throw(err);
//     } else if (error.status === 401) {
//       console.log('status', error.status);
//       const err = error.json();
//       err.responseStatus = error.status;
//       console.log('status', err.responseStatus);
//       return Observable.throw(err);
//     }
// });
// }
// IFSC validation
// public ifscValidation(formdata) {
//   console.log('inside services', formdata);

//   const data = {
//     "IFSC_Code":formdata.IFSC_Code,
//     "Bank_Name":formdata.Bank_Name
//   };
//   console.log('data', data);
//   const body = JSON.stringify(data);
//   console.log(body);
//   const head = new Headers({
//       'Content-Type': 'application/json'
//   });
//   return this.http.post(environment.baseUrl + '/validation/ifsc', body, {headers: head}).map((response: Response) => {
//     console.log(this.redirectUrl);
//     if (this.redirectUrl) {
//       this.router.navigate([this.redirectUrl]);
//       this.redirectUrl = null;
//     } else {
//       console.log(response.status);
//       const user = response.json();
//       user.responseStatus = response.status;
//       console.log(user);
//       return user;
//     }
//   }).catch((error) => {
//     console.log('error', error);
//     if (error.status === 500) {
//       console.log('status', error.status);
//       const err = error.json();
//       err.responseStatus = error.status;
//       console.log('status', err.responseStatus);
//       return Observable.throw(err);
//     } else if (error.status === 400) {
//       console.log('status', error.status);
//       const err = error.json();
//       err.responseStatus = error.status;
//       console.log('status', err.responseStatus);
//       return Observable.throw(err);
//     } else if (error.status === 401) {
//       console.log('status', error.status);
//       const err = error.json();
//       err.responseStatus = error.status;
//       console.log('status', err.responseStatus);
//       return Observable.throw(err);
//     }
// });
// }
}
